/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
export const MARVEL_APP_REGEX = /^https?:\/\/marvelapp\.com\/[a-zA-Z0-9]*/i;
export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const URL_REGEX =
  /(https?: \/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i;
export const FILL_BLANK_REGEX = /\{\{([a-z|A-Z|0-9|\u0621-\u064A.]+)\}\}/g;
export const STRIPE_CHECKOUT_REGEX =
  /^https:\/\/checkout\.(cartedo|stripe)\.com\/[a-zA-Z0-9_\/\-]+(#?[a-zA-Z0-9_%\/\-]*)?$/i;
